const view = {
    OPTIONS: 'OPTIONS',
    DETAILS: 'DETAILS',

};

const orderType = {
    PENDING: 'icon-omgmnt_pending',
    PROCESSING: 'icon-processing',
    TRANSIT: 'icon-mode_delivery',
};

const method = {
    courier: 'Deliver To:',
    pickup: '',
    hubspok: '',
    transit: 'En Route to:',
};

class OrderManagementItemController {
    constructor(settings) {
        this.view = view;
        this.settings = settings;
    }

    $onInit() {
        method.pickup = this.settings.orderManagement.itemPickupFrom;
        method.hubspok = this.settings.orderManagement.itemHubSpok;

        this.itemView = this.view.DETAILS;

        this.header = `<span class="orderManagementItem-icon" aria-hidden="true"><i class="${orderType[this.orderType]}"></i></span>`;
        this.header += `Order:&nbsp;<span class="orderManagementItem-orderNo">#${this.order.OrderId}</span>
                                        (${this.order.ItemCount} ${this.order.ItemCount > 1 ? 'items' : 'item'})`;

        this.method =
            this.orderType === 'transit' ? method.transit : method[this.order.DeliveryMethod.toLowerCase()];

        this.isEtaAvailable =
            (this.orderType !== 'PENDING') && this.order.DeliveryStartTime && this.order.DeliveryEndTime && (this.order.DeliveryStartTime !== this.order.DeliveryEndTime);

    }

    setView(newView) {
        this.itemView = newView;
    }
}

const orderManagementItemComponentDefinition = {
    bindings: {
        order: '<',
        orderType: '@',
        showTimer: '=',
    },
    transclude: true,
    controller: ['Settings', OrderManagementItemController],
    template: require('./order-management-item.component.html').trim(),
};

module.exports = {
    OrderManagementItemController,
    orderManagementItemComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/ordermanagement/order-management-item.component.js